import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find-index.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-885a7372"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "basic"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, "使用产品", -1);
});

var _hoisted_3 = {
  class: "tip"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconinfo"
  }, null, -1);
});

var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  key: 1
};
var _hoisted_7 = {
  class: "content"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "service-title"
  }, "可选应用", -1);
});

var _hoisted_9 = {
  class: "app-item"
};
var _hoisted_10 = {
  class: "name"
};
var _hoisted_11 = ["onClick"];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icona-setting_line14px"
  }, null, -1);
});

var _hoisted_13 = /*#__PURE__*/_createTextVNode(" 高级设置 ");

var _hoisted_14 = [_hoisted_12, _hoisted_13];
var _hoisted_15 = {
  class: "service-title"
};

var _hoisted_16 = /*#__PURE__*/_createTextVNode(" 基础服务 ");

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconinfo"
  }, null, -1);
});

var _hoisted_18 = {
  class: "app-item"
};
var _hoisted_19 = {
  class: "name"
};
var _hoisted_20 = ["onClick"];

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icona-setting_line14px"
  }, null, -1);
});

var _hoisted_22 = /*#__PURE__*/_createTextVNode(" 高级设置 ");

var _hoisted_23 = [_hoisted_21, _hoisted_22];
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { cloneDeep } from 'lodash';
import { ElMessageBox, ElMessage } from 'element-plus';
import CompanyService from '@/api/company';
import AdvancedSettingModal from '../Components/advancedSettingModal';
import { useAdvancedSetting } from './composables/useAdvancedSetting';
import store from '@/store'; // 是否是外网版本

export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _window$AppConfig;

    var outerWebFlag = window.AppConfig.outerWebFlag; // 高级设置弹窗 ref

    var advancedSettingRef = ref();

    var _useAdvancedSetting = useAdvancedSetting(advancedSettingRef),
        onOpenSettingDiolog = _useAdvancedSetting.onOpenSettingDiolog,
        settingList = _useAdvancedSetting.settingList;

    var route = useRoute();

    var _ref = ((_window$AppConfig = window.AppConfig) === null || _window$AppConfig === void 0 ? void 0 : _window$AppConfig.corporation) || {},
        _ref$enableOpenApp = _ref.enableOpenApp,
        enableOpenApp = _ref$enableOpenApp === void 0 ? false : _ref$enableOpenApp;

    var basicAppKeyList = ref([]);
    var allAppList = ref([]);
    var hasEditAuth = computed(function () {
      return store.state.company.hasEditAuth;
    });
    var alterAppList = computed(function () {
      var appList = cloneDeep(allAppList.value);
      var isInMicroApp = window.__MICRO_APP_ENVIRONMENT__;

      if (isInMicroApp) {
        var _window$microApp$getD = window.microApp.getData(),
            globalAPI = _window$microApp$getD.globalAPI;

        appList = appList.filter(function (app, index) {
          var _globalAPI$micro$getA, _globalAPI$micro$getA2;

          var appNameForMicroApp = (_globalAPI$micro$getA = globalAPI.micro.getAppConfig(app.app_key)) === null || _globalAPI$micro$getA === void 0 ? void 0 : (_globalAPI$micro$getA2 = _globalAPI$micro$getA.sidebar) === null || _globalAPI$micro$getA2 === void 0 ? void 0 : _globalAPI$micro$getA2.appName;

          if (appNameForMicroApp) {
            app.app_name = appNameForMicroApp;
            return true;
          }

          return false;
        });
      }

      return appList.filter(function (item) {
        return !basicAppKeyList.value.includes(item.app_key);
      });
    });
    var openedApps = computed(function () {
      return allAppList.value.filter(function (item) {
        return !!item.status;
      });
    });
    var basicAppList = computed(function () {
      var appList = cloneDeep(allAppList.value);
      var isInMicroApp = window.__MICRO_APP_ENVIRONMENT__;

      if (isInMicroApp) {
        var _window$microApp$getD2 = window.microApp.getData(),
            globalAPI = _window$microApp$getD2.globalAPI;

        appList = appList.filter(function (app, index) {
          var _globalAPI$micro$getA3, _globalAPI$micro$getA4;

          var appNameForMicroApp = (_globalAPI$micro$getA3 = globalAPI.micro.getAppConfig(app.app_key)) === null || _globalAPI$micro$getA3 === void 0 ? void 0 : (_globalAPI$micro$getA4 = _globalAPI$micro$getA3.sidebar) === null || _globalAPI$micro$getA4 === void 0 ? void 0 : _globalAPI$micro$getA4.appName;

          if (appNameForMicroApp) {
            app.app_name = appNameForMicroApp;
            return true;
          }

          return false;
        });
      }

      return appList.filter(function (item) {
        return basicAppKeyList.value.includes(item.app_key);
      });
    });

    var queryRequiredAppKeys = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$data;

        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CompanyService.getRequiredAppKeys({
                  corporationId: route.params.companyId
                });

              case 2:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  basicAppKeyList.value = data.data.result;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function queryRequiredAppKeys() {
        return _ref2.apply(this, arguments);
      };
    }();

    var queryAllApps = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data2;

        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return CompanyService.queryAllApps({
                  bizId: route.params.biz_url
                });

              case 2:
                data = _context2.sent;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  allAppList.value = data.data.result || [];
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function queryAllApps() {
        return _ref3.apply(this, arguments);
      };
    }();

    var openApp = function openApp(item) {
      ElMessageBox.confirm("\u786E\u8BA4\u5728\u8BE5\u7A7A\u95F4\u4E0B\u542F\u7528".concat(item.app_name, "?"), '启用应用', {
        type: '',
        confirmButtonText: '确认开启',
        cancelButtonText: '取消'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _data$data3;

        var appKeysList, data, _data$data4;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                appKeysList = openedApps.value.map(function (appItem) {
                  return appItem.app_key;
                });
                appKeysList.push(item.app_key);
                _context3.next = 4;
                return CompanyService.openApps({
                  appGroup: 'beacon',
                  bizId: route.params.biz_url,
                  appKeys: appKeysList === null || appKeysList === void 0 ? void 0 : appKeysList.join(',')
                });

              case 4:
                data = _context3.sent;

                if (((_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.code) === 1) {
                  queryAllApps();
                } else {
                  ElMessage({
                    message: data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.msg,
                    type: 'error'
                  });
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    };

    var closeApp = function closeApp(item) {
      ElMessageBox.confirm("\u5173\u95ED\u540E\uFF0C\u8BE5\u5E94\u7528\u4E0B\u5DF2\u6709\u7684\u6570\u636E\u5185\u5BB9\u5C06\u4E0D\u76F4\u63A5\u663E\u793A\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF0C\u786E\u8BA4\u5728\u8BE5\u7A7A\u95F4\u4E0B\u5173\u95ED".concat(item.app_name, "?"), '关闭应用', {
        type: '',
        confirmButtonText: '确认关闭',
        cancelButtonText: '取消'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _data$data5;

        var appKeysList, data, _data$data6;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                appKeysList = openedApps.value.map(function (appItem) {
                  return appItem.app_key;
                });
                appKeysList.splice(appKeysList.findIndex(function (v) {
                  return v === item.app_key;
                }), 1);
                _context4.next = 4;
                return CompanyService.openApps({
                  appGroup: 'beacon',
                  bizId: route.params.biz_url,
                  appKeys: (appKeysList === null || appKeysList === void 0 ? void 0 : appKeysList.length) > 0 ? appKeysList === null || appKeysList === void 0 ? void 0 : appKeysList.join(',') : ''
                });

              case 4:
                data = _context4.sent;

                if (((_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.code) === 1) {
                  queryAllApps();
                } else {
                  ElMessage({
                    message: data === null || data === void 0 ? void 0 : (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : _data$data6.msg,
                    type: 'error'
                  });
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    };

    var changeAppStatus = function changeAppStatus(val, item) {
      if (val) {
        openApp(item);
      } else {
        closeApp(item);
      }
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              queryAllApps();
              queryRequiredAppKeys();

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    return function (_ctx, _cache) {
      var _component_el_switch = _resolveComponent("el-switch");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _unref(enableOpenApp) ? (_openBlock(), _createElementBlock("span", _hoisted_5, "可由空间全局管理员等来自主控制可选应用的启用状态")) : (_openBlock(), _createElementBlock("span", _hoisted_6, " 当前为腾讯内网版，默认所有应用全部打开，且不可编辑"))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: _normalizeClass({
          'list-container': true,
          outer: _unref(outerWebFlag)
        })
      }, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alterAppList), function (item, idx) {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "app-list"
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(item.app_name), 1), !_unref(enableOpenApp) ? (_openBlock(), _createBlock(_component_el_switch, {
          key: 0,
          value: true,
          disabled: ""
        })) : (_openBlock(), _createBlock(_component_el_switch, {
          key: 1,
          value: item.status,
          onChange: function onChange(status) {
            return changeAppStatus(status, item);
          }
        }, null, 8, ["value", "onChange"]))]), item.switchFunctionConfig && !_unref(outerWebFlag) ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({
            'advanced-setting': true,
            'advanced-setting-disabled': !_unref(hasEditAuth)
          }),
          onClick: function onClick($event) {
            return _unref(onOpenSettingDiolog)(item.app_key, !_unref(hasEditAuth));
          }
        }, _hoisted_14, 10, _hoisted_11)) : _createCommentVNode("", true)]);
      }), 128))], 2), _createElementVNode("div", {
        class: _normalizeClass({
          'list-container': true,
          outer: _unref(outerWebFlag)
        })
      }, [_createElementVNode("p", _hoisted_15, [_hoisted_16, !_unref(enableOpenApp) ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        class: "box-item",
        effect: "dark",
        content: "基础服务默认为打开状态，无法关闭",
        placement: "top"
      }, {
        default: _withCtx(function () {
          return [_hoisted_17];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(basicAppList), function (item, idx) {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "app-list"
        }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(item.app_name), 1), _createVNode(_component_el_switch, {
          value: true,
          disabled: ""
        })]), item.switchFunctionConfig && !_unref(outerWebFlag) ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({
            'advanced-setting': true,
            'advanced-setting-disabled': !_unref(hasEditAuth)
          }),
          onClick: function onClick($event) {
            return _unref(onOpenSettingDiolog)(item.app_key, !_unref(hasEditAuth));
          }
        }, _hoisted_23, 10, _hoisted_20)) : _createCommentVNode("", true)]);
      }), 128))], 2)])]), _createVNode(_unref(AdvancedSettingModal), {
        ref_key: "advancedSettingRef",
        ref: advancedSettingRef,
        settingList: _unref(settingList)
      }, null, 8, ["settingList"])], 64);
    };
  }
});